export const FILTER_PRIORITY_LOWER_BOUND = 0;
export const FILTER_PRIORITY_UPPER_BOUND = 499;

export const SUPPRESSION_PRIORITY_LOWER_BOUND = 500;
export const SUPPRESSION_PRIORITY_UPPER_BOUND = 999;

export const ROUTING_PRIORITY_LOWER_BOUND = 1000;
export const ROUTING_PRIORITY_UPPER_BOUND = 2000;

export const MAX_NAME_FIELD_LENGTH = 255;
export const MAX_DESCRIPTION_FIELD_LENGTH = 255;
